import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import CustomInput from '~/components/CustomInput'
import Dialog from '~/components/Dialog'
import { formatNumber } from '~/utils/helpers'

type SubmitType = {
  name: string
  cowsNumber: string
  type: string | number | boolean | (string | number | boolean)[]
}

interface Props {
  isOpen: boolean
  handleClose: () => void
  handleSubmit: (data: SubmitType) => void
  max: number
  disableDryPeriodSplit: boolean
  maxTrockenCows: string
}

export const feedGroupTypes = [
  {
    value: 1,
    text: 'Trockensteher'
  },
  {
    value: 2,
    text: 'Laktierende 1'
  }
]

const AddNewGroup: React.FC<Props> = (props) => {
  const { isOpen, handleClose, handleSubmit, disableDryPeriodSplit } = props
  const { t } = useTranslation()

  const [feedGroupName, setFeedGroupName] = useState('')
  const [cowsNumber, setCowsNumber] = useState('')
  const [feedGroupType, setFeedGroupType] = useState<string | number | boolean | (string | number | boolean)[]>('')

  useEffect(() => {
    if (isOpen) {
      setCowsNumber('')
      setFeedGroupName('')
      setFeedGroupType('')
      setFeedGroupType(disableDryPeriodSplit ? 2 : '')
    }
  }, [isOpen])

  function renderAddNewFeedGroupForm() {
    return <Form>
      {!disableDryPeriodSplit && <Form.Field>
        <label style={{ fontStyle: 'italic' }}>
          {t('Please select whether you would like to create the new performance group based on dry cows or lactating cows. Please note that only one additional performance group can be created for dry cows.')}
        </label>
        <Form.Group>
          <Form.Checkbox
            label={'Trockensteher'}
            checked={feedGroupType === 1}
            onChange={() => setFeedGroupType(1)}
          />
          <Form.Checkbox
            label={'Laktierende'}
            checked={feedGroupType === 2}
            onChange={() => setFeedGroupType(2)}
          />
        </Form.Group>
      </Form.Field>}
      <Form.Group widths={'equal'}>
        <Form.Input
          label={t('Performance group name')}
          placeholder={t('Performance group name')}
          onChange={(_, data) => setFeedGroupName(data.value)}
          value={feedGroupName}
        />
        <Form.Field>
          <CustomInput
            label={t('Number of animals')}
            value={cowsNumber}
            placeholder={t('Number of animals')}
            styleLabel={{ marginBottom: '.5rem' }}
            withLabels
            allowDecimals={false}
            min={1}
            onChange={(value) => {
              if (!value) {
                setCowsNumber('')
                return
              }
              setCowsNumber(value)
            }}
          />
          {isMaxTiereError && <small style={{ color: 'red', fontStyle: 'italic' }}>
            {t('Max number of animals: {{tiere}}', { tiere: feedGroupType === 1 ? formatNumber(parseInt(props.maxTrockenCows) - 1, 0) : formatNumber(props.max - 1, 0) })}
          </small>}
        </Form.Field>
      </Form.Group>
    </Form>
  }

  function getMaxTiereNumber() {
    switch (feedGroupType) {
      case 1:
        return parseInt(cowsNumber) > parseInt(props.maxTrockenCows) - 1
      case 2:
        return parseInt(cowsNumber) > props.max - 1
      default:
        return parseInt(cowsNumber) > 1000000
    }
  }

  const isMaxTiereError = getMaxTiereNumber()

  return <Dialog
    textHeader={t('Add new performance group')}
    isDialogOpen={isOpen}
    minHeight={disableDryPeriodSplit ? '140px' : null}
    noScrollingContent
    disableSubmit={(!cowsNumber || !feedGroupName) || !feedGroupType || isMaxTiereError}
    textClose={t('Cancel')}
    textSubmit={t('Add')}
    handleClose={() => handleClose()}
    textContent={renderAddNewFeedGroupForm()}
    handleSubmit={() => handleSubmit({ name: feedGroupName, cowsNumber, type: feedGroupType })}
  />
}
export default AddNewGroup